import React from 'react';
import { ArrowLeft, CircleHelp, LogOut } from 'lucide-react';

function AdminDashboardHeader({
  canReturnToSuperAdmin,
  onLogout,
  onOpenSetupCard,
  onStartTour,
  onReturnToSuperAdmin,
  setupProgress,
  user
}) {
  return (
    <>
      {canReturnToSuperAdmin && (
        <div className="impersonation-banner">
          <span>You are impersonating this company.</span>
          <button type="button" onClick={onReturnToSuperAdmin}>
            <ArrowLeft className="btn-icon" size={16} />
            <span>Back to Super Admin</span>
          </button>
        </div>
      )}
      <header className="dashboard-header">
        <div className="dashboard-header-main">
          <h1>Operations Console</h1>
          <p className="dashboard-header-subtitle">Inventory, orders, and access control</p>
        </div>
        <div className="user-info">
          <span className="header-welcome-pill">
            {user.username === 'admin' && user.real_name
              ? `Welcome back, ${user.real_name}`
              : `Welcome back, ${user.username}`}
          </span>
          {typeof onStartTour === 'function' ? (
            <button
              type="button"
              className="header-help-btn"
              onClick={onStartTour}
              aria-label="Open help tour"
              title="Open help tour"
            >
              <CircleHelp className="btn-icon" size={16} />
              <span>Help</span>
            </button>
          ) : null}
          {typeof onOpenSetupCard === 'function' && setupProgress ? (
            <button type="button" className="header-setup-btn" onClick={onOpenSetupCard}>
              Checklist {setupProgress}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onLogout}
            className="logout-btn"
            aria-label="Log out"
            title="Log out"
          >
            <LogOut className="btn-icon" size={16} />
            <span>Log out</span>
          </button>
        </div>
      </header>
    </>
  );
}

export default AdminDashboardHeader;
